import { getLoginRedirectUri, getPopupRedirectUri, loginRequest, shouldUseRedirectLogin } from '../../config/auth';
import msalInstance from './auth';

/**
 * Attempts to get a token silently and if silent fails attempts using popup.
 *
 * @returns `[token, error]: [string | null, unknown]`
 */
async function getToken(): Promise<string | null> {
  let token = null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: msalInstance.getAllAccounts()[0],
    });
    token = response.accessToken;
  } catch (err) {
    if (err) {
      try {
        if (shouldUseRedirectLogin()) {
          await msalInstance.acquireTokenRedirect({
            ...loginRequest,
            account: msalInstance.getAllAccounts()[0],
            redirectUri: getLoginRedirectUri(),
          });
          return null;
        }

        const response = await msalInstance.acquireTokenPopup({
          ...loginRequest,
          redirectUri: getPopupRedirectUri(),
        });
        token = response.accessToken;
      } catch (err) {
        /** Something went wrong and all token acquisitions failed, clear storage and redirect to login */
        window.sessionStorage.clear();
        window.location.replace('/');
      }
    }
  }

  return token;
}

export default getToken;
